<div class="employee-tenant-access">
  <!-- Header with buttons -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">
      <i class="bi bi-key me-2"></i>
      {{ 'EmployeeTenantAccess.title' | translate }}
    </h5>
    
    <button type="button" class="btn btn-primary btn-sm" (click)="openGrantAccessModal()" [disabled]="!isUserAdmin"
            [title]="!isUserAdmin ? ('EmployeeTenantAccess.adminRequired' | translate) : ('EmployeeTenantAccess.grantAccess' | translate)">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'EmployeeTenantAccess.grantAccess' | translate }}
    </button>
  </div>

  <!-- Description -->
  <div class="alert alert-info mb-3">
    <i class="bi bi-info-circle me-2"></i>
    {{ 'EmployeeTenantAccess.description' | translate }}
  </div>

  <!-- Smart Grid -->
  <div class="row" *ngIf="columns.length > 0 && !loading">
    <div class="col-12">
      <konti-smart-grid 
        [data]="employeeAccess?.rows || []" 
        [columns]="columns" 
        [initialSort]="[{ field: 'employeeName', dir: 'asc' }]"
        [showGroupPanel]="false">
        
        <!-- Actions column template -->
        <ng-template appSmartGridCell="__actions__" let-row>
          <div class="action-capsule btn-group btn-group-sm sg-desktop-only">
            <button class="btn btn-outline-danger action-danger" 
                    (click)="revokeAccess(row)"
                    [disabled]="!isUserAdmin"
                    [title]="'EmployeeTenantAccess.revokeAccess' | translate">
              <i class="bi bi-x-circle" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'EmployeeTenantAccess.revokeAccess' | translate }}</span>
            </button>
          </div>
        </ng-template>
      </konti-smart-grid>
    </div>
  </div>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && employeeAccess.rows.length === 0" class="text-center py-5">
    <i class="bi bi-key display-1 text-muted"></i>
    <h5 class="text-muted mt-3">{{ 'EmployeeTenantAccess.noAccess' | translate }}</h5>
    <p class="text-muted">{{ 'EmployeeTenantAccess.noAccessDesc' | translate }}</p>
    <button type="button" class="btn btn-primary" (click)="openGrantAccessModal()" [disabled]="!isUserAdmin">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'EmployeeTenantAccess.grantFirstAccess' | translate }}
    </button>
  </div>
</div>

<!-- Revoke Confirmation Modal (MANDATORY PATTERN - NEVER use alert/confirm) -->
<ng-template #revokeConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle text-warning me-2"></i>
      {{ 'EmployeeTenantAccess.confirmRevokeTitle' | translate }}
    </h5>
    <button type="button" class="btn-close" (click)="cancelRevoke()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'EmployeeTenantAccess.confirmRevoke' | translate }}</p>
    <div class="alert alert-warning mb-0" *ngIf="itemToRevoke">
      <strong>{{ 'EmployeeTenantAccess.user' | translate }}:</strong> {{ itemToRevoke.employeeName }}<br>
      <strong>{{ 'EmployeeTenantAccess.group' | translate }}:</strong> {{ itemToRevoke.groupName }}
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelRevoke()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmRevoke()">
      <i class="bi bi-x-circle me-1"></i>
      {{ 'EmployeeTenantAccess.revokeAccess' | translate }}
    </button>
  </div>
</ng-template>
